import {type FC} from "react"
import {Box, Stack} from "@mui/material"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import TextSeparator from "../../atoms/separator/TextSeparator"
import {ThoughtPiecesAuthorModel} from "../../../types/ThoughtPiecesModel"
import {TruncatedTooltip} from "../../atoms/Tooltip"

type Props = {
  title: string
  date: string
  articleTag: string
  author: ThoughtPiecesAuthorModel[]
}

const discoverSidePanelItem: FC<Props> = (props) => {
  const {title, date, articleTag, author} = props

  return (
    <Box
      id="moleculeDiscoverSidePanelItemBox"
      style={{
        paddingTop: "3.4px",
        paddingBottom: "3.4px",
        marginLeft: "8px",
        marginRight: "9px",
        maxHeight: "102.84px",
      }}
    >
      <Stack>
        <Box
          style={{
            padding: "0px",
            fontSize: "12px",
            textAlign: "start",
            marginBottom: "4px",
            color: "#595958",
            lineHeight: "1.33",
            display: "flex",
            flexDirection: "row",
            overflow: "hidden",
          }}
        >
          {author && author[0] ? (
            <>
              <Box>
                <EllipsisTypography
                  text={author[0].name}
                  lines={1}
                  fontSize={12}
                  tooltipComponent={TruncatedTooltip}
                ></EllipsisTypography>
              </Box>
              <TextSeparator
                separator="|"
                distanceX="7px"
                fontSize="10px"
                paddingTop="1.5px"
              />
            </>
          ) : (
            ""
          )}
          <Box>
            <EllipsisTypography
              text={date}
              lines={1}
              fontSize={12}
              tooltipComponent={TruncatedTooltip}
            ></EllipsisTypography>
          </Box>
        </Box>
        <Box
          data-parent-hover={true}
          sx={{
            padding: "0px",
            textAlign: "start",
            color: "#242d35",
            fontWeight: 500,
            lineHeight: "1.43",
            marginBottom: "4px",
          }}
        >
          <EllipsisTypography
            text={title}
            lines={2}
            fontSize={16}
            tooltipComponent={TruncatedTooltip}
          ></EllipsisTypography>
        </Box>
        <Box
          style={{
            padding: "0px",
            textAlign: "start",
            color: "#595958",
          }}
        >
          <EllipsisTypography
            text={articleTag}
            lines={1}
            fontSize={14}
            tooltipComponent={TruncatedTooltip}
          ></EllipsisTypography>
        </Box>
      </Stack>
    </Box>
  )
}

export default discoverSidePanelItem
